import styled from 'styled-components';

import { ACTIVITY_BUILDER_HEADER_HEIGHT } from 'approot/activity-builder/activity-builder.constants';
import { rem } from 'approot/shared/style';
import { grey1, grey10, grey5 } from 'approot/shared/styles/colours.style';
import {
  baseFlexCss,
  flexSpaceBetweenCss,
} from 'approot/shared/styles/flex.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { font12 } from 'approot/shared/styles/typography.style';

export const ActivityAnswersPrintHeader = styled.div`
  ${flexSpaceBetweenCss}
  background-color: ${grey1};
  border-bottom: 1px solid ${grey5};
  height: ${rem(ACTIVITY_BUILDER_HEADER_HEIGHT)};
  padding: 0 ${rem(spacing24)};
  position: relative;

  svg {
    flex-shrink: 0;
    height: ${rem(40)};
    width: ${rem(120)};
    margin-right: ${rem(spacing24)};
    position: relative;
  }
`;

export const ActivityAnswersPrintHeaderUser = styled.div`
  ${baseFlexCss}
  width: 50%;
`;

export const ActivityAnswersPrintHeaderDetails = styled.div`
  width: 50%;
  text-align: right;
`;

export const ActivityAnswerPrintHeaderUserName = styled.p`
  ${font12}
  color: ${grey10};
  margin-bottom: 0;
`;

export const ActivityAnswerPrintHeaderText = styled.p`
  ${font12}
  color: ${grey10};
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
